<template>
  <b-list-group
    v-b-hover="handleHover"
    class="bg-gray-primary rounded-0 collapsed-menu vh-100 pb-5"
    :class="{ 'expanded-menu': isMenuExpanded }"
  >
    <b-list-group-item
      class="rounded-0 border-0 clickable mt-2 px-3"
      @click="goToDashboard"
    >
      <b-row class="no-gutters text-white flex-nowrap align-items-end">
        <b-col class="col-auto">
          <img
            width="28px"
            src="./../assets/icons/Icon-Emotiva-2020.svg"
            fluid
            alt="logo"
          />
        </b-col>
        <b-col v-if="isMenuExpanded" class="ml-3 h5 mb-0">Emotiva</b-col>
      </b-row>
    </b-list-group-item>
    <b-list-group-item
      v-b-visible="handleExpandItemVisibility"
      class="rounded-0 border-0 clickable d-lg-none"
      @click="isExpandItemActive = !isExpandItemActive"
    >
      <b-icon icon="list" variant="white" font-scale="1.0"></b-icon>
    </b-list-group-item>
    <b-list-group-item
      class="rounded-0 border-0 mt-4 clickable"
      :class="{ 'bg-color-light': isRouteActive('Dashboard') }"
      @click="goToPage('Dashboard')"
    >
      <b-row class="no-gutters text-white flex-nowrap align-items-end">
        <b-col class="col-auto">
          <img
            src="./../assets/icons/users.svg"
            class="menu__icon"
            :class="{ 'active__menu-icon': isRouteActive('Dashboard') }"
          />
        </b-col>
        <b-col
          v-if="isMenuExpanded"
          class="menu__text-item"
          :class="{ menu__text__active: isRouteActive('Dashboard') }"
        >
          {{ $t("sideMenu.users") }}
        </b-col>
      </b-row>
    </b-list-group-item>
    <b-list-group-item
      v-if="platform === 'empower' || platform === 'dev'"
      class="rounded-0 border-0 clickable"
      :class="{ 'bg-color-light': isRouteActive('Clients') }"
      @click="goToPage('Clients')"
    >
      <b-row class="no-gutters text-white flex-nowrap align-items-end">
        <b-col class="col-auto">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-person-lines-fill menu__icon"
            :class="{ 'active__menu-icon': isRouteActive('Clients') }"
          >
            <path
              fill-rule="evenodd"
              d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7 1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm2 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
            />
          </svg>
          <!-- <img
            src="./../assets/icons/users.svg"
            class="menu__icon"
            :class="{ 'active__menu-icon': isRouteActive('Clients') }"
          /> -->
        </b-col>
        <b-col
          v-if="isMenuExpanded"
          class="menu__text-item"
          :class="{ menu__text__active: isRouteActive('Clients') }"
        >
          {{ $t("sideMenu.clients") }}
        </b-col>
      </b-row>
    </b-list-group-item>

    <b-list-group-item v-if="platform === 'dev'"></b-list-group-item>
    <div v-if="platform === 'foresight' || platform === 'dev'">
      <b-list-group-item
        class="rounded-0 border-0 clickable"
        :class="{ 'bg-color-light': isRouteActive('Predict-Clients') }"
        @click="goToPage('Predict-Clients')"
      >
        <b-row class="no-gutters text-white flex-nowrap align-items-end">
          <b-col class="col-auto">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-person-lines-fill menu__icon"
              :class="{ 'active__menu-icon': isRouteActive('Predict-Clients') }"
            >
              <path
                fill-rule="evenodd"
                d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7 1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm2 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </b-col>
          <b-col
            v-if="isMenuExpanded"
            class="menu__text-item"
            :class="{ menu__text__active: isRouteActive('Predict-Clients') }"
          >
            {{ $t("sideMenu.predictClients") }}
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="rounded-0 border-0 clickable"
        :class="{ 'bg-color-light': isRouteActive('External-Clients') }"
        @click="goToPage('External-Clients')"
      >
        <b-row class="no-gutters text-white flex-nowrap align-items-end">
          <b-col class="col-auto">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-person-lines-fill menu__icon"
              :class="{ 'active__menu-icon': isRouteActive('External-Clients') }"
            >
              <path
                fill-rule="evenodd"
                d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7 1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm2 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </b-col>
          <b-col
            v-if="isMenuExpanded"
            class="menu__text-item"
            :class="{ menu__text__active: isRouteActive('External-Clients') }"
          >
            <!-- {{ $t("sideMenu.externalClients") }} -->
              Milano-fiere clients
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="rounded-0 border-0 clickable"
        :class="{ 'bg-color-light': isRouteActive('Services') }"
        @click="goToPage('Services')"
      >
        <b-row class="no-gutters text-white flex-nowrap align-items-end">
          <b-col class="col-auto">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-person-lines-fill menu__icon"
              :class="{ 'active__menu-icon': isRouteActive('Services') }"
            >
              <path
                fill-rule="evenodd"
                d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7 1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm2 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </b-col>
          <b-col
            v-if="isMenuExpanded"
            class="menu__text-item"
            :class="{ menu__text__active: isRouteActive('Services') }"
          >
            {{ $t("sideMenu.services") }}
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="rounded-0 border-0 clickable"
        :class="{ 'bg-color-light': isRouteActive('Subscriptions') }"
        @click="goToPage('Subscriptions')"
      >
        <b-row class="no-gutters text-white flex-nowrap align-items-end">
          <b-col class="col-auto">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-person-lines-fill menu__icon"
              :class="{ 'active__menu-icon': isRouteActive('Subscriptions') }"
            >
              <path
                fill-rule="evenodd"
                d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7 1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm2 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </b-col>
          <b-col
            v-if="isMenuExpanded"
            class="menu__text-item"
            :class="{ menu__text__active: isRouteActive('Subscriptions') }"
          >
            {{ $t("sideMenu.subscriptions") }}
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="rounded-0 border-0 clickable"
        :class="{ 'bg-color-light': isRouteActive('Groups') }"
        @click="goToPage('Groups')"
      >
        <b-row class="no-gutters text-white flex-nowrap align-items-end">
          <b-col class="col-auto">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-people-fill menu__icon"
              :class="{ 'active__menu-icon': isRouteActive('Groups') }"
            >
              <path
                d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
              />
            </svg>
          </b-col>
          <b-col
            v-if="isMenuExpanded"
            class="menu__text-item"
            :class="{ menu__text__active: isRouteActive('Groups') }"
          >
            {{ $t("sideMenu.groups") }}
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="rounded-0 border-0 clickable"
        :class="{ 'bg-color-light': isRouteActive('Release-Notes') }"
        @click="goToPage('Release-Notes')"
      >
        <b-row class="no-gutters text-white flex-nowrap align-items-end">
          <b-col class="col-auto">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-megaphone-fill menu__icon"
              :class="{ 'active__menu-icon': isRouteActive('Release-Notes') }"
            >
              <path
                d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z"
              />
            </svg>
          </b-col>
          <b-col
            v-if="isMenuExpanded"
            class="menu__text-item"
            :class="{ menu__text__active: isRouteActive('Release-Notes') }"
          >
            {{ $t("sideMenu.releaseNotes") }}
          </b-col>
        </b-row>
      </b-list-group-item>
    </div>

    <b-list-group-item
      class="rounded-0 border-0 mt-4 clickable"
      :class="{ 'bg-color-light': isRouteActive('Support') }"
      @click="goToPage('Support')"
    >
      <b-row class="no-gutters text-white flex-nowrap align-items-end">
        <b-col class="col-auto">
          <img
            src="./../assets/icons/MENU_support-faq.svg"
            class="menu__icon"
            :class="{ 'active__menu-icon': isRouteActive('Support') }"
          />
        </b-col>
        <b-col
          v-if="isMenuExpanded"
          class="menu__text-item"
          :class="{ menu__text__active: isRouteActive('Support') }"
        >
          {{ $t("sideMenu.support") }}
        </b-col>
      </b-row>
    </b-list-group-item>

    <b-list-group-item
      class="rounded-0 border-0 clickable"
      :class="{ 'bg-color-light': isRouteActive('Settings') }"
      @click="goToPage('Settings')"
    >
      <b-row class="no-gutters text-white flex-nowrap align-items-end">
        <b-col class="col-auto">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-gear-fill menu__icon"
            :class="{ 'active__menu-icon': isRouteActive('Settings') }"
          >
            <path
              d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
            />
          </svg>
        </b-col>
        <b-col
          v-if="isMenuExpanded"
          class="menu__text-item"
          :class="{ menu__text__active: isRouteActive('Settings') }"
        >
          {{ $t("sideMenu.settings") }}
        </b-col>
      </b-row>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import Config from "../plugins/Config";
export default {
  created() {},
  data() {
    return {
      isHovered: false,
      isExpandItemActive: false,
      isExpandItemVisible: false,
    };
  },
  watch: {
    isExpandItemVisible: {
      handler: function () {
        // Close menu on window resize
        if (this.isExpandItemVisible) this.isExpandItemActive = false;
        else this.isHovered = false;
      },
      immediate: false,
    },
  },
  computed: {
    isMenuExpanded() {
      return this.isExpandItemVisible
        ? this.isExpandItemActive
        : this.isHovered;
    },
    platform() {
      console.log("Value: ",Config.value("platform"))
      return Config.value("platform") || "dev";
    },
  },
  methods: {
    handleHover(hovered) {
      this.isHovered = hovered;
    },
    handleExpandItemVisibility(val) {
      this.isExpandItemVisible = val;
    },
    goToDashboard() {
      if (this.$route.name !== "Dashboard" && this.$route.name !== "Login") {
        this.isHovered = false;
        this.isExpandItemActive = false;
        this.$router.push({ name: "Dashboard" });
      }
    },
    goToPage(routeName) {
      if (this.$route.name !== routeName) {
        this.isHovered = false;
        this.isExpandItemActive = false;
        this.$router.push({ name: routeName });
      }
    },
    isRouteActive(routeName) {
      return this.$route.name === routeName;
    },
  },
};
</script>

<style scoped>
.collapsed-menu {
  transition: width 0.5s ease;
  z-index: 3;
  width: 60px;
  overflow-x: hidden;
  overflow-y: auto;
}
.expanded-menu {
  transition: width 0.5s ease;
  width: 240px;
}
.bg-gray-primary {
  background-color: #3f3f3f;
}
.list-group-item {
  background-color: #3f3f3f;
}
.menu__text-item {
  font-size: 14px;
  font-weight: 400;
  margin-left: 30px;
}
.menu__text__active {
  color: #3f3f3f;
  font-weight: 700;
}
.bg-color-light {
  background-color: #f8f9fa;
}
.menu__icon {
  width: 14px;
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(43deg)
    brightness(102%) contrast(101%);
}
.active__menu-icon {
  filter: invert(0%) sepia(85%) saturate(7500%) hue-rotate(173deg)
    brightness(87%) contrast(113%);
}
</style>
